import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AdalService } from '../adal/adal.service';
import { AppSettingsService } from './appsettings.service'; 


export interface Func<T, T1, T2, TResult> {
    (item: T, item1: T1, item2: T2): TResult;
}

export interface IRequestInterceptor {
    beforeRequestAsync(url: string, method: string, data: any): Promise<boolean>;
}

export interface IResponseInterceptor {
    afterResponseAsync(response: any, url: string, method: string, data: any): Promise<boolean>;
}

@Injectable()
export class AuthHttp {
    private _http: Http;
    private _requestInterceptors: IRequestInterceptor[] = [];
    private _responseInterceptors: IResponseInterceptor[] = [];
    private _customCookieToHeaders = [];
    private _baseUrl;
    private _withCredentials;

    constructor(http: Http
        //protected adalService: AdalService,
        //protected adConfig: AppSettingsService,    
    ) {
        this._http = http;
        this.registerRequestInterceptor({
            beforeRequestAsync: function (url, method, data) {
                return new Promise((resolve, reject) => {
                    // do something 

                    // resolve with true to fully intercept request
                    // resolve with false to let the request continue
                    //var resource = this.adalService.GetResourceForEndpoint(url);
                    //var authenticatedCall: Observable<any>;


                    //if (resource) {

                    //    if (this.adalService.userInfo.isAuthenticated) {
                    //        authenticatedCall = this.adalService.acquireToken(resource)
                    //            .flatMap((token: string) => {
                    //                if (options1.headers == null) {
                    //                    options1.headers = new Headers();
                    //                }
                    //                options1.headers.append('Authorization', 'Bearer ' + token);
                    //                return super.request(url, options1)
                    //                    .do(this.decrementRequestCount)
                    //                    .catch(this.handleError);
                    //            });
                    //    }
                    //    else {
                    //        authenticatedCall = Observable.throw(new Error("User Not Authenticated."));
                    //    }
                    //}
                    //else {
                    //    authenticatedCall = super.request(url, options).map(this.extractData).catch(this.handleError);
                    //}
                    resolve(false);
                });
            }
        });
    } 

    public registerBaseUrl(baseUrl: string): void {
        this._baseUrl = baseUrl;

        if (this._baseUrl[this._baseUrl.length - 1] !== '/') {
            this._baseUrl += '/';
        }
    }

    public setWithCredentials(status: boolean): void {
        this._withCredentials = status;
    }

    public registerRequestInterceptor(requestInterceptor: IRequestInterceptor): void {
        this._requestInterceptors.push(requestInterceptor);
    }

    public deregisterRequestInterceptor(requestInterceptor: IRequestInterceptor): boolean {
        let indexOfItem = this._requestInterceptors.indexOf(requestInterceptor);

        if (indexOfItem === -1) {
            return false;
        }

        this._requestInterceptors.splice(indexOfItem, 1);

        return true;
    }

    public registerResponseInterceptor(responseInterceptor: IResponseInterceptor): void {
        this._responseInterceptors.push(responseInterceptor);
    }

    public deregisterResponseInterceptor(responseInterceptor: IResponseInterceptor): boolean {
        let indexOfItem = this._responseInterceptors.indexOf(responseInterceptor);

        if (indexOfItem === -1) {
            return false;
        }

        this._responseInterceptors.splice(indexOfItem, 1);

        return true;
    }

    public sendCookieValueInCustomHeader(cookieName: string, customHeaderName: string): void {
        this._customCookieToHeaders.push({
            cookieName: cookieName,
            customHeaderName: customHeaderName
        });
    }

    public async getAsync(url: string, options: RequestOptions = new RequestOptions()): Promise<any> {
        let that = this;

        return await that.requestCoreAsync(url, 'GET', null, options, (url, data, modOptions) => {
            return that._http.get(url, modOptions);
        });
    }

    public async postAsync(url: string, data?: any, options: RequestOptions = new RequestOptions()): Promise<any> {
        let that = this;

        return await that.requestCoreAsync(url, 'POST', data, options, (url, data, modOptions) => {
            return that._http.post(url, data, modOptions);
        });
    }

    public async putAsync(url: string, data?: any, options: RequestOptions = new RequestOptions()): Promise<any> {
        let that = this;

        return await that.requestCoreAsync(url, 'PUT', data, options, (url, data, modOptions) => {
            return that._http.put(url, data, modOptions);
        });
    }

    public async deleteAsync(url: string, options: RequestOptions = new RequestOptions()): Promise<any> {
        let that = this;

        return await that.requestCoreAsync(url, 'DELETE', null, options, (url, data, modOptions) => {
            return that._http['delete'](url, modOptions);
        });
    }

    public async patchAsync(url: string, data?: any, options: RequestOptions = new RequestOptions()): Promise<any> {
        let that = this;

        return await that.requestCoreAsync(url, 'PATCH', data, options, (url, data, modOptions) => {
            return that._http.patch(url, data, modOptions);
        });
    }

    public async headAsync(url: string, options: RequestOptions = new RequestOptions()): Promise<any> {
        let that = this;

        return await that.requestCoreAsync(url, 'HEAD', null, options, (url, data, modOptions) => {
            return that._http.head(url, modOptions);
        });
    }

    private async requestCoreAsync(url: string, method: string, data: any, options: RequestOptions, action: Func<string, any, RequestOptions, Observable<Response>>): Promise<any> {
        options.headers = options.headers || new Headers();

        url = this.convertUrl(url);

        //this.appendGlobalHeaders(options.headers);


        let shouldIntercept = await this.invokeRequestInterceptorsAsync(url, method, data);

        if (shouldIntercept) {
            return;
        }

        let response;

        try {
            response = await action(url, data, options).toPromise();
        }
        catch (errorResponse) {
            response = errorResponse;
        }

        shouldIntercept = await this.invokeResponseInterceptorsAsync(response, url, method, data);

        if (shouldIntercept) {
            return;
        }

        if (!response.ok) {
            throw new Error(`Failed to call api ${method} ${url}`);
        }

        let returnValue;

        try {
            returnValue = response.json();
        }
        catch (e) {
            returnValue = response.text();
        }

        return returnValue;
    }

    public getObservable(url: string, options: RequestOptions = new RequestOptions()): Observable<Response> {
        let that = this;

        return that.requestCoreObservable(url, 'GET', null, options, (url, data, modOptions) => {
            return that._http.get(url, modOptions);
        });
    }

    public postObservable(url: string, data: any, options: RequestOptions = new RequestOptions()): Observable<Response> {
        let that = this;

        return that.requestCoreObservable(url, 'POST', data, options, (url, data, modOptions) => {
            return that._http.post(url, data, modOptions);
        });
    }

    public putObservable(url: string, data: any, options: RequestOptions = new RequestOptions()): Observable<Response> {
        let that = this;

        return that.requestCoreObservable(url, 'PUT', data, options, (url, data, modOptions) => {
            return that._http.put(url, data, modOptions);
        });
    }

    public deleteObservable(url: string, options: RequestOptions = new RequestOptions()): Observable<Response> {
        let that = this;

        return that.requestCoreObservable(url, 'DELETE', null, options, (url, data, modOptions) => {
            return that._http['delete'](url, modOptions);
        });
    }

    public patchObservable(url: string, data: any, options: RequestOptions = new RequestOptions()): Observable<Response> {
        let that = this;

        return that.requestCoreObservable(url, 'PATCH', data, options, (url, data, modOptions) => {
            return that._http.patch(url, data, modOptions);
        });
    }

    public headObservable(url: string, options: RequestOptions = new RequestOptions()): Observable<Response> {
        let that = this;

        return that.requestCoreObservable(url, 'HEAD', null, options, (url, data, modOptions) => {
            return that._http.head(url, modOptions);
        });
    }

    private requestCoreObservable(url: string, method: string, data: any, options: RequestOptions, action: Func<string, any, RequestOptions, Observable<Response>>): Observable<Response> {
        return Observable.fromPromise(this.requestCoreAsync(url, method, data, options, action));
    }

    private convertUrl(url: string) {
        let returnUrl = url;

        if (this._baseUrl) {
            returnUrl = this._baseUrl + returnUrl;
        }

        return returnUrl;
    }

    private modifyOptions(options: RequestOptions) {
        if (this._withCredentials) {
            options.withCredentials = true;
        }
    }

    

    private async invokeRequestInterceptorsAsync(url: string, method: string, data: any): Promise<boolean> {
        for (const requestInterceptor of this._requestInterceptors) {
            const shouldIntercept = await requestInterceptor.beforeRequestAsync(url, method, data);

            if (shouldIntercept) {
                return true;
            }
        }

        return false;
    }

    private async invokeResponseInterceptorsAsync(response: Response, url: string, method: string, data: any): Promise<boolean> {
        for (const responseInterceptor of this._responseInterceptors) {
            const shouldIntercept = await responseInterceptor.afterResponseAsync(response, url, method, data);

            if (shouldIntercept) {
                return true;
            }
        }

        return false;
    }

}


// WEBPACK FOOTER //
// ./app/services/adal-async-http.service.ts